import { notifications } from '@mantine/notifications';
import { addDoc, collection, deleteDoc, disableNetwork, doc, enableNetwork, getDoc, onSnapshot, query, setDoc, updateDoc, where } from 'firebase/firestore';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { useEffect, useRef, useState } from 'react';
import { db } from '../../../servicos/firebase';

// Novos componentes refatorados

// Sub-seções
import BarraLateral from '../componentes/BarraLateral';
import SecaoAgenda from './secoes/SecaoAgenda';
import SecaoAssinatura from './secoes/SecaoAssinatura';
import SecaoConfiguracoes from './secoes/SecaoConfiguracoes';
import SecaoDashboard from './secoes/SecaoDashboard';
import SecaoEquipe from './secoes/SecaoEquipe';
import SecaoFidelizacao from './secoes/SecaoFidelizacao';
import SecaoFinanceiro from './secoes/SecaoFinanceiro';
import SecaoMarketing from './secoes/SecaoMarketing';
import SecaoServicos from './secoes/SecaoServicos';

import './PainelDono.css';

const PLAN_LIMITS = {
    profissional: 20
};

const SUBSCRIPTION_PLANS_INFO = {
    profissional: { name: 'Profissional', price: 'R$ 120,00' }
};

const SUBSCRIPTION_PLANS = {
    profissional: { name: 'Profissional', price: 120.00, limit: 20 }
};



// Helpers to format and parse currency
const formatCurrency = (value) => {
    if (value === undefined || value === null || isNaN(value)) value = 0;
    return `R$ ${Number(value).toFixed(2).replace('.', ',')}`;
};

const parsePrice = (priceStr) => {
    if (!priceStr) return 0;
    if (typeof priceStr === 'number') return priceStr;
    if (typeof priceStr !== 'string') return 0;
    // Remove R$, whitespace and convert comma to dot
    const cleanValue = priceStr.replace(/[R$\s]/g, '').replace(',', '.');
    const parsed = parseFloat(cleanValue);
    return isNaN(parsed) ? 0 : parsed;
};

const parseDuration = (durationStr) => {
    if (!durationStr) return 60;
    let totalMinutes = 0;
    const hoursMatch = durationStr.match(/(\d+)\s*h/);
    const minsMatch = durationStr.match(/(\d+)\s*min/);
    if (hoursMatch) totalMinutes += parseInt(hoursMatch[1]) * 60;
    if (minsMatch) totalMinutes += parseInt(minsMatch[1]);
    if (totalMinutes === 0) {
        const numMatch = durationStr.match(/(\d+)/);
        totalMinutes = numMatch ? parseInt(numMatch[1]) : 60;
    }
    return totalMinutes;
};

const PainelDono = ({ appointments, onUpdateStatus, onBack, user, barbers = [], services = [], blockedTimes = [], systemBlocks = [], currentTenant, config, globalBroadcast }) => {

    const [showTransferModal, setShowTransferModal] = useState(false);
    const [renewalCycle, setRenewalCycle] = useState(1);
    const [selectedAppForTransfer, setSelectedAppForTransfer] = useState(null);
    const [selectedBarber, setSelectedBarber] = useState('Todos');
    const [selectedDate, setSelectedDate] = useState(new Date().toLocaleDateString('sv-SE'));
    const [timeFilter, setTimeFilter] = useState('Hoje'); // 'Hoje', 'Semana', 'Mes', 'Total'

    // Settings States
    const [newServiceName, setNewServiceName] = useState('');
    const [newServicePrice, setNewServicePrice] = useState('R$ 0,00');
    const [newServiceCategory, setNewServiceCategory] = useState('Geral');
    const [newServiceDuration, setNewServiceDuration] = useState('1h');
    const [newBarberName, setNewBarberName] = useState('');
    const [newBarberImage, setNewBarberImage] = useState('/imagens/fotobarber.PNG');
    const [newBarberEmail, setNewBarberEmail] = useState('');
    const [newBarberPhone, setNewBarberPhone] = useState('');
    const [newBarberRole, setNewBarberRole] = useState('barber');
    const [newClosedDay, setNewClosedDay] = useState('');
    const [newClosedReason, setNewClosedReason] = useState('Manutenção / Reforma');
    const [activeSection, setActiveSection] = useState('dashboard'); // dashboard, agenda, services, team, settings, reviews
    const [collapsedCategories, setCollapsedCategories] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [systemLogs, setSystemLogs] = useState([]);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [editingServiceId, setEditingServiceId] = useState(null);
    const [editingDuration, setEditingDuration] = useState('');
    const [editingPriceId, setEditingPriceId] = useState(null);
    const [editingPrice, setEditingPrice] = useState('');
    const [editingBarberId, setEditingBarberId] = useState(null);
    const [barberWorkingHours, setBarberWorkingHours] = useState({
        'Seg': { active: true, start: '08:00', end: '19:00', lunchActive: false, lunchStart: '12:00', lunchEnd: '13:00' },
        'Ter': { active: true, start: '08:00', end: '19:00', lunchActive: false, lunchStart: '12:00', lunchEnd: '13:00' },
        'Qua': { active: true, start: '08:00', end: '19:00', lunchActive: false, lunchStart: '12:00', lunchEnd: '13:00' },
        'Qui': { active: true, start: '08:00', end: '19:00', lunchActive: false, lunchStart: '12:00', lunchEnd: '13:00' },
        'Sex': { active: true, start: '08:00', end: '19:00', lunchActive: false, lunchStart: '12:00', lunchEnd: '13:00' },
        'Sab': { active: true, start: '08:00', end: '19:00', lunchActive: false, lunchStart: '12:00', lunchEnd: '13:00' },
        'Dom': { active: false, start: '08:00', end: '19:00', lunchActive: false, lunchStart: '12:00', lunchEnd: '13:00' },
    });

    // Image Adjustment States
    const [isCropping, setIsCropping] = useState(false);
    const [tempImage, setTempImage] = useState(null);
    const [cropZoom, setCropZoom] = useState(1);
    const [cropX, setCropX] = useState(0);
    const [cropY, setCropY] = useState(0);
    const [tempAspect, setTempAspect] = useState(1);
    const [isEditingGoal, setIsEditingGoal] = useState(false);
    const [agendaSearch, setAgendaSearch] = useState('');
    const [agendaStatusFilter, setAgendaStatusFilter] = useState('Todos');
    const [isDragging, setIsDragging] = useState(false);
    const [lastPointerPos, setLastPointerPos] = useState({ x: 0, y: 0 });
    const cropContainerRef = useRef(null);

    const [isBroadcastDismissed, setIsBroadcastDismissed] = useState(
        sessionStorage.getItem(`dismissed_broadcast_${globalBroadcast?.updatedAt} `) === 'true'
    );

    // Unit Config States
    const [unitAddress, setUnitAddress] = useState(config?.address || '');
    const [unitMapsUrl, setUnitMapsUrl] = useState(config?.mapsUrl || '');
    const [unitHours, setUnitHours] = useState(Array.isArray(config?.openingHours) ? config.openingHours.join('\n') : config?.openingHours || '');
    const [unitWhatsapp, setUnitWhatsapp] = useState(config?.whatsapp || '');
    const [unitInstagram, setUnitInstagram] = useState(config?.instagram || '');
    const [unitLogo, setUnitLogo] = useState(config?.logoUrl || '');
    const currentMonthKey = new Date().toISOString().slice(0, 7); // "YYYY-MM"
    const [revenueGoal, setRevenueGoal] = useState(config?.revenueGoalMonth === currentMonthKey ? config?.revenueGoal || 0 : 0);
    const [croppingType, setCroppingType] = useState('barber'); // 'barber' or 'logo'

    // Blocking States
    const [blockBarber, setBlockBarber] = useState('Todos');
    const [blockDate, setBlockDate] = useState(new Date().toISOString().split('T')[0]);
    const [blockStart, setBlockStart] = useState('08:00');
    const [blockEnd, setBlockEnd] = useState('20:00');
    const [blockReason, setBlockReason] = useState('Folga / Intervalo');

    const addLog = (msg, type = 'info') => {
        const newLog = { id: Date.now(), msg, type, time: new Date().toLocaleTimeString() };
        setSystemLogs(prev => [newLog, ...prev].slice(0, 5));
    };

    const showToast = (message, type = 'success') => {
        notifications.show({
            title: type === 'success' ? 'Sucesso' : type === 'error' ? 'Erro' : 'Informação',
            message: message,
            color: type === 'success' ? 'green' : type === 'error' ? 'red' : 'blue',
            autoClose: 3000,
        });
    };

    const [financeiroStartDate, setFinanceiroStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0]);
    const [financeiroEndDate, setFinanceiroEndDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().split('T')[0]);
    const [currentExpandedBarber, setCurrentExpandedBarber] = useState(null);
    const [expenses, setExpenses] = useState([]);
    const [newExpense, setNewExpense] = useState({
        description: '',
        amount: '',
        category: 'Variável',
        date: new Date().toISOString().split('T')[0]
    });
    const [loadingExpenses, setLoadingExpenses] = useState(false);

    // Sync with external config changes (parent updates)
    useEffect(() => {
        if (config) {
            setUnitAddress(config.address || '');
            setUnitMapsUrl(config.mapsUrl || '');
            setUnitHours(Array.isArray(config.openingHours) ? config.openingHours.join('\n') : config.openingHours || '');
            setUnitWhatsapp(config.whatsapp || '');
            setUnitInstagram(config.instagram || '');
            setUnitLogo(config.logoUrl || '');
            const currentMonthKey = new Date().toISOString().slice(0, 7);
            setRevenueGoal(config.revenueGoalMonth === currentMonthKey ? config.revenueGoal || 0 : 0);
        }
    }, [config]);

    // Sync Expenses
    useEffect(() => {
        if (!currentTenant || (activeSection !== 'dashboard' && activeSection !== 'financeiro')) return;

        const qExpenses = query(collection(db, "expenses"), where("barbershopId", "==", currentTenant));
        const unsub = onSnapshot(qExpenses, (snap) => {
            setExpenses(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });

        return () => unsub();
    }, [currentTenant, activeSection]);

    const toggleCategory = (cat) => {
        setCollapsedCategories(prev =>
            prev.includes(cat) ? prev.filter(c => c !== cat) : [...prev, cat]
        );
    };

    const handlePing = async () => {
        try {
            if (!db?.app?.options?.projectId) {
                addLog('Erro: Firestore não inicializado corretamente no App.', 'error');
                return;
            }
            addLog(`Projeto Ativo: ${db.app.options.projectId} `, 'info');
            addLog('Iniciando Ping (Leitura)...', 'info');
            const testRef = doc(db, "config", "settings");
            const snap = await withTimeout(getDoc(testRef), 10000);
            if (snap.exists()) {
                addLog('Ping OK! Banco respondendo.', 'success');
            } else {
                addLog('Ping Falhou: Banco vazio (isso é normal no início).', 'success');
            }
        } catch (error) {
            addLog('Erro no Ping: ' + error.message, 'error');
            console.error("Ping error:", error);
        }
    };

    const handleResetNetwork = async () => {
        try {
            addLog('Reiniciando conexão de rede do Firebase...', 'info');
            await disableNetwork(db);
            await new Promise(r => setTimeout(r, 1000));
            await enableNetwork(db);
            addLog('Rede reiniciada! Tente operar novamente.', 'success');
        } catch (error) {
            addLog('Erro ao reiniciar rede: ' + error.message, 'error');
        }
    };

    const handleClearCache = async () => {
        try {
            addLog('Limpando cache do navegador...', 'info');
            // We need to wait for the app to be idle, but we'll try direct termination
            window.location.reload(); // Usually a reload is cleaner for persistence clearing
        } catch (error) {
            addLog('Erro ao limpar cache: ' + error.message, 'error');
        }
    };

    const handleEmergencySync = async () => {
        if (!window.confirm("Isso tentará 'empurrar' os dados para o Google sem verificar se há internet. Tentar?")) return;
        try {
            if (!db?.app?.options?.projectId) {
                addLog('Erro: Projeto não configurado.', 'error');
                return;
            }
            addLog(`Sync p / Projeto: ${db.app.options.projectId} `, 'info');
            addLog('Iniciando Gravação...', 'info');
            // Try only the first barber as test
            const testBarber = { id: 'test-ping', name: 'Teste de Sistema', image: '/imagens/fotobarber.PNG' };
            await withTimeout(setDoc(doc(db, "barbers", "test-ping"), testBarber), 10000);
            addLog('Sucesso total! O Google aceitou os dados.', 'success');
            showToast('O Google respondeu! Sistema operacional.');
        } catch (error) {
            addLog('Falha Crítica: ' + error.message, 'error');
            console.error("Emergency sync failed:", error);
            showToast('Erro Técnico: Verifique o console ou as regras.', 'error');
        }
    };


    const handleSaveUnitConfig = async () => {
        if (!unitAddress) {
            notifications.show({
                title: 'Atenção',
                message: 'O endereço é obrigatório',
                color: 'orange'
            });
            return;
        }

        try {
            addLog('Salvando configurações da unidade...', 'info');
            const hoursArray = unitHours.split('\n').filter(line => line.trim() !== '');

            const currentMonthKey = new Date().toISOString().slice(0, 7);
            await updateDoc(doc(db, "tenants", currentTenant), {
                address: unitAddress,
                mapsUrl: unitMapsUrl,
                openingHours: hoursArray,
                whatsapp: unitWhatsapp,
                instagram: unitInstagram,
                logoUrl: unitLogo,
                revenueGoal: Number(revenueGoal),
                revenueGoalMonth: currentMonthKey
            });

            addLog('Configurações salvas com sucesso!', 'success');
            showToast('Localização e Horários atualizados!');
        } catch (error) {
            addLog('Erro ao salvar configurações: ' + error.message, 'error');
            console.error("Save config error:", error);
            showToast('Erro ao salvar: ' + (error.code || 'Verifique o Firebase'), 'error');
        }
    };

    const handleClearOldAppointments = async () => {
        if (!window.confirm("Isso removerá TODOS os agendamentos de meses anteriores. Deseja continuar?")) return;

        try {
            addLog('Iniciando limpeza de agenda antiga...', 'info');
            const now = new Date();
            const firstOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);

            const oldApps = appointments.filter(app => {
                const appDate = new Date(app.date + 'T00:00:00');
                return appDate < firstOfCurrentMonth;
            });

            if (oldApps.length === 0) {
                showToast('Nenhum agendamento antigo encontrado.');
                return;
            }

            let deletedCount = 0;
            for (const app of oldApps) {
                try {
                    await deleteDoc(doc(db, "tenants", currentTenant, "appointments", app.id));
                    deletedCount++;
                } catch (e) {
                    console.error("Error deleting app:", app.id, e);
                }
            }

            addLog(`${deletedCount} agendamentos antigos removidos com sucesso.`, 'success');
            showToast(`Limpeza concluída: ${deletedCount} itens removidos.`);
        } catch (error) {
            addLog('Erro ao limpar agenda: ' + error.message, 'error');
            showToast('Erro ao limpar agenda antiga', 'error');
        }
    };

    const withTimeout = (promise, ms = 30000) => {
        let timeoutId;
        const timeoutPromise = new Promise((_, reject) => {
            timeoutId = setTimeout(() => {
                reject(new Error('Tempo esgotado. Verifique o banco no Firebase.'));
            }, ms);
        });

        return Promise.race([
            Promise.resolve(promise).then(res => {
                if (timeoutId) clearTimeout(timeoutId);
                return res;
            }),
            timeoutPromise
        ]).finally(() => {
            if (timeoutId) clearTimeout(timeoutId);
        });
    };

    // Extract unique barbers from registered barbers list
    const registeredBarberNames = barbers.map(b => b.name);
    const uniqueBarbers = ['Todos', ...new Set([...registeredBarberNames, ...appointments
        .filter(app => app.barber !== 'SHOP' && app.barber !== 'SISTEMA')
        .map(app => app.barber)])].filter(Boolean);

    // Today's Date in YYYY-MM-DD (local time)
    const today = new Date().toLocaleDateString('sv-SE');

    // Filter human appointments (exclude system closures)
    const humanAppointments = appointments.filter(app => app.status !== 'Sistema_Bloqueado');

    // Calendar Grid Logic (Moved up for metrics)
    const timeSlots = [];
    for (let h = 4; h <= 23; h++) {
        for (let m = 0; m < 60; m += 5) {
            timeSlots.push(`${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')} `);
        }
    }

    // Filter appointments
    const filteredAppointments = appointments.filter(app => {
        if (app.status === 'Sistema_Bloqueado') return false;

        const barberMatch = selectedBarber === 'Todos' || app.barber === selectedBarber;

        if (activeSection === 'financeiro') {
            const appDate = new Date(app.date + 'T00:00:00');
            const startStr = financeiroStartDate;
            const endStr = financeiroEndDate;
            const start = new Date(startStr + 'T00:00:00');
            const end = new Date(endStr + 'T23:59:59');
            return barberMatch && appDate >= start && appDate <= end;
        }

        if (timeFilter === 'Total') return barberMatch;

        const appDate = new Date(app.date + 'T00:00:00');
        const now = new Date();
        now.setHours(0, 0, 0, 0);

        if (timeFilter === 'Hoje') {
            return barberMatch && app.date === today;
        }

        if (timeFilter === 'Semana') {
            const startOfWeek = new Date(now);
            startOfWeek.setDate(now.getDate() - now.getDay()); // Início da semana (Domingo)
            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 6);
            endOfWeek.setHours(23, 59, 59, 999);
            return barberMatch && appDate >= startOfWeek && appDate <= endOfWeek;
        }

        if (timeFilter === 'Mes') {
            const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
            const lastOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
            return barberMatch && appDate >= firstOfMonth && appDate <= lastOfMonth;
        }

        return barberMatch;
    });

    // Sort filtered appointments
    const sortedAppointments = [...filteredAppointments].sort((a, b) => {
        if (a.date !== b.date) return a.date.localeCompare(b.date);
        return a.time.localeCompare(b.time);
    });

    // List for UI Agenda (refined with search and status filters)
    // IMPORTANT: We use the full appointments list here to allow navigating to any date,
    // independent of the dashboard's timeFilter.
    const agendaAppointments = [...appointments]
        .sort((a, b) => {
            if (a.date !== b.date) return a.date.localeCompare(b.date);
            return a.time.localeCompare(b.time);
        })
        .filter(app => {
            if (app.status === 'Sistema_Bloqueado') return false;

            const matchesSearch = !agendaSearch ||
                app.client.toLowerCase().includes(agendaSearch.toLowerCase()) ||
                (app.whatsapp && app.whatsapp.includes(agendaSearch));

            const matchesStatus = agendaStatusFilter === 'Todos' || app.status === agendaStatusFilter;
            const matchesBarber = selectedBarber === 'Todos' || app.barber === selectedBarber;

            // In the new Agenda, we want to see everything unless explicitly filtered, 
            // but by default we exclude cancelled unless "Todos" or "Cancelado" is selected as filter
            const isDefaultVisible = agendaStatusFilter !== 'Todos' || app.status !== 'Cancelado';

            return matchesSearch && matchesStatus && matchesBarber && isDefaultVisible && app.date === selectedDate;
        });

    // Grouping by Date
    const getTomorrowDate = () => {
        const d = new Date();
        d.setDate(d.getDate() + 1);
        return d.toISOString().split('T')[0];
    };
    const tomorrow = getTomorrowDate();

    const groupedAgenda = agendaAppointments.reduce((acc, app) => {
        const groupLabel = app.date === today ? 'Hoje' : app.date.split('-').reverse().join('/');
        if (!acc[groupLabel]) acc[groupLabel] = [];
        acc[groupLabel].push(app);
        return acc;
    }, {});

    // Metrics calculation based on filtered period
    const periodAppointments = sortedAppointments;
    const periodRevenue = periodAppointments
        .filter(app => app.status !== 'Cancelado')
        .reduce((total, app) => total + parsePrice(app.price), 0);

    const periodAverageTicket = periodAppointments.length > 0
        ? (periodRevenue / periodAppointments.filter(app => app.status !== 'Cancelado').length || 0)
        : 0;

    const confirmedCount = periodAppointments.filter(app => app.status === 'Confirmado').length;
    const completedCount = periodAppointments.filter(app => app.status === 'Concluido').length;

    // Monthly Goal Calculation (Current Month always)
    const now = new Date();
    const firstOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastOfCurrentMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
    const currentMonthRevenue = appointments
        .filter(app => {
            const appDate = new Date(app.date + 'T00:00:00');
            return app.status !== 'Cancelado' && app.status !== 'Sistema_Bloqueado' &&
                appDate >= firstOfCurrentMonth && appDate <= lastOfCurrentMonth;
        })
        .reduce((total, app) => total + parsePrice(app.price), 0);

    const goalProgress = Math.min((currentMonthRevenue / (revenueGoal || 1)) * 100, 100).toFixed(1);

    // Occupancy Rate (heuristic: minutes filled vs capacity in minutes)
    const activeBarbersCount = barbers.length || 1;
    // Capacity per day per barber: number of slots * 5 minutes
    const minutesPerDayPerBarber = timeSlots.length * 5;
    const dailyCapacityMinutes = activeBarbersCount * minutesPerDayPerBarber;

    // Count days in period
    const uniqueDays = new Set(periodAppointments.map(app => app.date));
    const totalPeriodCapacityMinutes = (uniqueDays.size || 1) * dailyCapacityMinutes;

    const totalBookedMinutes = periodAppointments
        .filter(app => app.status !== 'Cancelado' && app.status !== 'Sistema_Bloqueado')
        .reduce((sum, app) => {
            let duration = app.durationMinutes;
            if (!duration) {
                const serviceNames = (app.service || "").split(' + ');
                duration = serviceNames.reduce((acc, name) => {
                    const srv = services.find(s => s.name === name);
                    return acc + (srv ? parseDuration(srv.duration) : 0);
                }, 0);
                if (duration === 0) duration = 30;
            }
            return sum + duration;
        }, 0);

    const occupancyRate = totalPeriodCapacityMinutes > 0
        ? ((totalBookedMinutes / totalPeriodCapacityMinutes) * 100).toFixed(1)
        : 0;

    // Expense Calculation for the filtered period
    const periodExpenses = expenses.filter(e => {
        const expenseDate = new Date(e.date + 'T00:00:00');
        const now = new Date();
        now.setHours(0, 0, 0, 0);

        if (activeSection === 'financeiro') {
            const start = new Date(financeiroStartDate + 'T00:00:00');
            const end = new Date(financeiroEndDate + 'T23:59:59');
            return expenseDate >= start && expenseDate <= end;
        }

        if (timeFilter === 'Hoje') return e.date === today;
        if (timeFilter === 'Semana') {
            const startOfWeek = new Date(now);
            startOfWeek.setDate(now.getDate() - now.getDay());
            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 6);
            return expenseDate >= startOfWeek && expenseDate <= endOfWeek;
        }
        if (timeFilter === 'Mes') {
            const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
            const lastOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
            return expenseDate >= firstOfMonth && expenseDate <= lastOfMonth;
        }
        return true;
    }).reduce((acc, e) => acc + e.amount, 0);

    const periodNetProfit = periodRevenue - periodExpenses;

    // Ghost Clients Logic (Retention)
    const ghostClients = (() => {
        const clientLastVisit = {};
        const clientFutureApps = new Set();
        const todayDate = new Date();
        todayDate.setHours(0, 0, 0, 0);

        appointments.forEach(app => {
            if (app.status === 'Cancelado') return;

            const clientKey = app.whatsapp || app.client;
            const appDate = new Date(app.date + 'T00:00:00');

            if (appDate > todayDate) {
                clientFutureApps.add(clientKey);
            }

            if (!clientLastVisit[clientKey] || appDate > clientLastVisit[clientKey].date) {
                clientLastVisit[clientKey] = {
                    date: appDate,
                    name: app.client,
                    whatsapp: app.whatsapp,
                    lastService: app.service
                };
            }
        });

        return Object.keys(clientLastVisit)
            .filter(key => {
                const lastVisit = clientLastVisit[key].date;
                const diffTime = Math.abs(todayDate - lastVisit);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                return diffDays >= 25 && !clientFutureApps.has(key);
            })
            .map(key => {
                const diffTime = Math.abs(todayDate - clientLastVisit[key].date);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                return {
                    ...clientLastVisit[key],
                    daysSinceLastVisit: diffDays
                };
            })
            .sort((a, b) => b.daysSinceLastVisit - a.daysSinceLastVisit);
    })();

    // Monthly Performance Logic
    const getMonthlyRevenue = () => {
        const revenueByMonth = {};
        const monthNames = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

        // Generate last 3 months safely
        const now = new Date();
        for (let i = 2; i >= 0; i--) {
            const d = new Date(now.getFullYear(), now.getMonth(), 1);
            d.setMonth(d.getMonth() - i);
            const key = `${monthNames[d.getMonth()]}/${d.getFullYear().toString().slice(-2)}`;
            revenueByMonth[key] = 0;
        }

        appointments.forEach(app => {
            if (app.status === 'Cancelado' || !app.date) return;

            // Safer parsing: try matching YYYY-MM-DD first
            let monthIndex, yearShort;
            const parts = app.date.split('-');

            if (parts.length === 3) {
                // Assuming YYYY-MM-DD
                monthIndex = parseInt(parts[1], 10) - 1;
                yearShort = parts[0].slice(-2);
            } else {
                // Fallback to Date object if format is different
                const appDate = new Date(app.date);
                if (isNaN(appDate.getTime())) return;
                monthIndex = appDate.getMonth();
                yearShort = appDate.getFullYear().toString().slice(-2);
            }

            const key = `${monthNames[monthIndex]}/${yearShort}`;
            if (revenueByMonth.hasOwnProperty(key)) {
                revenueByMonth[key] += parsePrice(app.price);
            }
        });

        const maxRevenue = Math.max(...Object.values(revenueByMonth), 500); // at least 500 for scale
        const entries = Object.entries(revenueByMonth);

        return entries.map(([month, revenue], index) => {
            let growth = null;
            if (index > 0) {
                const prevRevenue = entries[index - 1][1];
                if (prevRevenue > 0) {
                    growth = ((revenue - prevRevenue) / prevRevenue * 100).toFixed(1);
                } else if (revenue > 0) {
                    growth = "100";
                }
            }

            return {
                month,
                revenue,
                height: (revenue / maxRevenue) * 100,
                growth: growth ? (parseFloat(growth) > 0 ? `+${growth}%` : `${growth}%`) : null
            };
        });
    };

    const monthlyData = getMonthlyRevenue();

    const getBarberPerformance = () => {
        const stats = {};
        periodAppointments.forEach(app => {
            if (app.status === 'Cancelado' || app.status === 'Sistema_Bloqueado') return;
            const barber = app.barber || 'Não Definido';
            if (!stats[barber]) {
                stats[barber] = { name: barber, count: 0, revenue: 0, total: 0 };
            }
            stats[barber].count++;
            const price = parsePrice(app.price);
            stats[barber].revenue += price;
            stats[barber].total += price;
        });

        // Convert to array and sort by total
        return Object.values(stats)
            .sort((a, b) => b.total - a.revenue);
    };

    const barberPerformance = getBarberPerformance();

    // Barber Specific Insights
    const getBarberInsights = () => {
        if (selectedBarber === 'Todos') return null;

        const barberApps = appointments.filter(app => app.barber === selectedBarber);
        const todayApps = barberApps.filter(app => app.date === today);

        const nextApp = todayApps
            .filter(app => app.status !== 'Concluido' && app.status !== 'Cancelado')
            .sort((a, b) => a.time.localeCompare(b.time))[0];

        const services = barberApps.reduce((acc, app) => {
            acc[app.service] = (acc[app.service] || 0) + 1;
            return acc;
        }, {});
        const topService = Object.entries(services).sort((a, b) => b[1] - a[1])[0]?.[0] || 'Nenhum';

        const todayRev = todayApps
            .filter(app => app.status !== 'Cancelado')
            .reduce((total, app) => total + parsePrice(app.price), 0);

        const ratedApps = barberApps.filter(app => app.rating);
        const avgRating = ratedApps.length > 0
            ? (ratedApps.reduce((sum, app) => sum + app.rating, 0) / ratedApps.length).toFixed(1)
            : 'N/A';

        return {
            nextClient: nextApp ? `${nextApp.time} - ${nextApp.client}` : 'Nenhum hoje',
            topService,
            commission: todayRev * 0.5,
            remaining: todayApps.filter(app => app.status !== 'Concluido' && app.status !== 'Cancelado').length,
            avgRating
        };
    };

    const insights = getBarberInsights();


    const handleRemind = (app) => {
        let number = app.whatsapp;

        if (!number) {
            number = window.prompt(`O cliente ${app.client} não tem WhatsApp cadastrado. Digite o número (com DDD) para enviar a mensagem:`);
            if (!number) return;
        }

        const cleanNumber = number.replace(/\D/g, '');
        if (cleanNumber.length < 10) {
            showToast('Número inválido. Use o formato (DDD) 99999-9999', 'error');
            return;
        }

        const finalNumber = cleanNumber.startsWith('55') ? cleanNumber : `55${cleanNumber}`;
        const shopName = config?.name || 'Barbearia';
        const message = `Olá, *${app.client}*!\n\nPassando para confirmar seu horário na **${shopName}**:\n\n*Data:* ${app.date.split('-').reverse().join('/')}\n*Horário:* ${app.time}\n*Serviço:* ${app.service}\n*Valor:* ${app.price}\n\nEstamos preparando tudo para te receber! Nos vemos em breve.`;
        const url = `https://wa.me/${finalNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');

        // Perguntar se quer marcar como enviado
        setTimeout(() => {
            if (window.confirm("Deseja marcar este lembrete como enviado?")) {
                markAsReminded(app.id);
            }
        }, 1000);
    };

    const markAsReminded = async (appId) => {
        try {
            const appRef = doc(db, 'appointments', appId);
            await updateDoc(appRef, { reminderSent: true });
            showToast('Lembrete marcado como enviado!', 'success');
        } catch (error) {
            console.error("Erro ao marcar lembrete:", error);
            showToast('Erro ao atualizar status do lembrete.', 'error');
        }
    };

    const pendingReminders = (() => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const tomorrowStr = tomorrow.toISOString().split('T')[0];

        return appointments.filter(app =>
            app.date === tomorrowStr &&
            !app.reminderSent &&
            app.status !== 'Cancelado'
        );
    })();

    const generateMonthlyReport = () => {
        const doc = new jsPDF();
        const now = new Date();
        const currentMonth = now.getMonth();
        const currentYear = now.getFullYear();
        const monthNames = ['JANEIRO', 'FEVEREIRO', 'MARÇO', 'ABRIL', 'MAIO', 'JUNHO', 'JULHO', 'AGOSTO', 'SETEMBRO', 'OUTUBRO', 'NOVEMBRO', 'DEZEMBRO'];

        // Filter appointments for current month
        const monthlyApps = appointments.filter(app => {
            const appDate = new Date(app.date + 'T00:00:00');
            return appDate.getMonth() === currentMonth &&
                appDate.getFullYear() === currentYear &&
                app.status === 'Concluido';
        });

        const totalMonthRevenue = monthlyApps.reduce((sum, app) => sum + parsePrice(app.price), 0);
        const avgTicket = monthlyApps.length > 0 ? totalMonthRevenue / monthlyApps.length : 0;

        // Goal Calculation for PDF
        const goalVal = Number(revenueGoal) || 0;
        const goalPercent = goalVal > 0 ? Math.min((totalMonthRevenue / goalVal) * 100, 100).toFixed(1) : 0;
        const goalStatusText = totalMonthRevenue >= goalVal && goalVal > 0 ? "META BATIDA" : `${goalPercent}% ALCANÇADO`;

        // --- NEW EXECUTIVE DESIGN ---

        // Professional Header
        doc.setFillColor(0, 0, 0); // Black top bar
        doc.rect(0, 0, 210, 15, 'F');

        doc.setFont('helvetica', 'bold');
        doc.setFontSize(22);
        doc.setTextColor(0, 0, 0);
        doc.text('RELATÓRIO DE FECHAMENTO', 14, 35);

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(10);
        doc.setTextColor(100, 100, 100);
        doc.text(`UNIDADE: ${currentTenant.toUpperCase()}`, 14, 42);
        doc.text(`PERÍODO: ${monthNames[currentMonth]} / ${currentYear}`, 14, 47);
        doc.text(`EMISSÃO: ${now.toLocaleString()}`, 14, 52);

        // Divider
        doc.setDrawColor(0);
        doc.setLineWidth(1.5);
        doc.line(14, 58, 196, 58);

        // Summary Grid (Including Goal Status)
        autoTable(doc, {
            startY: 65,
            head: [['Atendimentos', 'Faturamento Total', 'Meta do Mês', 'Status da Meta']],
            body: [[
                monthlyApps.length,
                formatCurrency(totalMonthRevenue),
                formatCurrency(goalVal),
                goalStatusText
            ]],
            theme: 'grid',
            headStyles: {
                fillColor: [30, 30, 30],
                textColor: [255, 255, 255],
                fontSize: 10,
                halign: 'center',
                cellPadding: 4
            },
            styles: {
                fontSize: 12,
                fontStyle: 'bold',
                halign: 'center',
                cellPadding: 6,
                textColor: [0, 0, 0]
            }
        });

        // Performance by Barber (Monochrome styled)
        const barberStats = monthlyApps.reduce((acc, app) => {
            if (!acc[app.barber]) acc[app.barber] = { count: 0, revenue: 0 };
            acc[app.barber].count++;
            acc[app.barber].revenue += parsePrice(app.price);
            return acc;
        }, {});

        const barberTableData = Object.entries(barberStats).map(([name, data]) => [
            name.toUpperCase(),
            data.count,
            formatCurrency(data.revenue)
        ]);

        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.setTextColor(50);
        doc.text('DESEMPENHO POR PROFISSIONAL', 14, doc.lastAutoTable.finalY + 15);

        autoTable(doc, {
            startY: doc.lastAutoTable.finalY + 20,
            head: [['BARBEIRO', 'ATENDIMENTOS', 'FATURAMENTO']],
            body: barberTableData,
            theme: 'striped',
            headStyles: { fillColor: [80, 80, 80], halign: 'left' },
            bodyStyles: { halign: 'left' },
            alternateRowStyles: { fillColor: [245, 245, 245] }
        });

        // Most Popular Services (Executive Grid)
        const serviceCountsMonth = monthlyApps.reduce((acc, app) => {
            acc[app.service] = (acc[app.service] || 0) + 1;
            return acc;
        }, {});

        const sortedServices = Object.entries(serviceCountsMonth)
            .sort((a, b) => b[1] - a[1])
            .slice(0, 8);

        doc.text('ANÁLISE DE SERVIÇOS (TOP 8)', 14, doc.lastAutoTable.finalY + 15);

        autoTable(doc, {
            startY: doc.lastAutoTable.finalY + 20,
            head: [['SERVIÇO', 'VOLUME DE ATENDIMENTOS']],
            body: sortedServices,
            theme: 'grid',
            headStyles: { fillColor: [120, 120, 120] },
            styles: { fontSize: 9 }
        });

        // Footer
        const finalY = 285;
        doc.setFontSize(8);
        doc.setTextColor(150);
        doc.text(`Relatório Administrativo Gerado em ${now.toLocaleString()}`, 14, finalY);
        doc.text(`Página 1 de 1`, 180, finalY);

        doc.save(`Fechamento_${currentTenant}_${monthNames[currentMonth]}.pdf`);
    };

    const generateDailyAgendaPDF = () => {
        showToast('Gerando agenda do dia...', 'info');
        const doc = new jsPDF();
        const now = new Date();
        const dateStr = selectedDate;
        const formattedDate = dateStr.split('-').reverse().join('/');

        // Filter appointments for selected day and barber
        const dailyApps = appointments.filter(app => {
            const barberMatch = selectedBarber === 'Todos' || app.barber === selectedBarber;
            return app.date === dateStr && barberMatch;
        }).sort((a, b) => a.time.localeCompare(b.time));

        // Header
        doc.setFillColor(30, 30, 30);
        doc.rect(0, 0, 210, 20, 'F');

        doc.setFont('helvetica', 'bold');
        doc.setFontSize(18);
        doc.setTextColor(255, 255, 255);
        doc.text('AGENDA DIÁRIA', 14, 13);

        doc.setFontSize(10);
        doc.text(currentTenant.toUpperCase(), 196, 13, { align: 'right' });

        doc.setTextColor(0, 0, 0);
        doc.setFontSize(12);
        doc.text(`Data: ${formattedDate}`, 14, 30);
        doc.text(`Profissional: ${selectedBarber}`, 14, 37);

        // Table
        const tableData = dailyApps.map(app => [
            app.time,
            app.client.toUpperCase(),
            app.service,
            app.barber,
            app.price,
            app.status.toUpperCase()
        ]);

        autoTable(doc, {
            startY: 45,
            head: [['HORA', 'CLIENTE', 'SERVIÇO', 'PROFISSIONAL', 'VALOR', 'STATUS']],
            body: tableData.length > 0 ? tableData : [['-', 'NENHUM AGENDAMENTO ENCONTRADO', '-', '-', '-', '-']],
            theme: 'grid',
            headStyles: { fillColor: [60, 60, 60], textColor: [255, 255, 255], halign: 'center' },
            columnStyles: {
                0: { halign: 'center', fontStyle: 'bold' },
                4: { halign: 'right' },
                5: { halign: 'center' }
            },
            styles: { fontSize: 9, cellPadding: 4 }
        });

        // Footer
        const finalY = doc.internal.pageSize.height - 10;
        doc.setFontSize(8);
        doc.setTextColor(150, 150, 150);
        doc.text(`Gerado em ${now.toLocaleString('pt-BR')} | Página 1`, 14, finalY);

        doc.save(`Agenda_${currentTenant}_${dateStr}.pdf`);
        showToast('Agenda exportada com sucesso!', 'success');
    };

    const handleAddService = async () => {
        if (!newServiceName) return;
        if (!currentTenant) {
            showToast('Erro: ID da barbearia não identificado.', 'error');
            return;
        }
        try {
            addLog(`Tentando adicionar serviço: ${newServiceName}`, 'info');
            await withTimeout(addDoc(collection(db, "services"), {
                name: newServiceName,
                price: newServicePrice,
                category: newServiceCategory,
                duration: newServiceDuration,
                barbershopId: currentTenant
            }));
            setNewServiceName('');
            setNewServicePrice('R$ 0,00');
            addLog('Serviço adicionado com sucesso ao Firestore!', 'success');
            showToast('Serviço adicionado com sucesso!');
        } catch (error) {
            addLog('Erro ao salvar serviço: ' + error.message, 'error');
            console.error("Erro ao adicionar serviço:", error);
            showToast('Erro ao adicionar serviço: ' + error.message, 'error');
        }
    };

    const handleUpdateServiceDuration = async (serviceId) => {
        if (!editingDuration) {
            setEditingServiceId(null);
            return;
        }
        try {
            await updateDoc(doc(db, "services", serviceId), {
                duration: editingDuration
            });
            showToast('Duração atualizada!');
            setEditingServiceId(null);
        } catch (error) {
            showToast('Erro ao atualizar duração', 'error');
        }
    };

    const handleUpdateServicePrice = async (serviceId) => {
        if (!editingPrice) {
            setEditingPriceId(null);
            return;
        }
        try {
            await updateDoc(doc(db, "services", serviceId), {
                price: editingPrice
            });
            showToast('Preço atualizado!');
            setEditingPriceId(null);
        } catch (error) {
            showToast('Erro ao atualizar preço', 'error');
        }
    };
    const handleDeleteService = async (serviceId) => {
        if (window.confirm("Deseja realmente excluir este serviço?")) {
            try {
                await deleteDoc(doc(db, "services", serviceId));
                showToast('Serviço excluído');
            } catch (error) {
                console.error("Erro ao excluir serviço:", error);
                showToast('Erro ao excluir serviço', 'error');
            }
        }
    };

    const handleApplyCrop = () => {
        setUploading(true);
        const img = new Image();
        img.onload = async () => {
            const canvas = document.createElement('canvas');

            // Define canvas size based on type
            // Barbers: Square (400x400)
            // Logos: Rectangular (600x400) for better flexibility
            const isLogo = croppingType === 'logo';
            const CANVAS_W = isLogo ? 600 : 400;
            const CANVAS_H = 400;

            canvas.width = CANVAS_W;
            canvas.height = CANVAS_H;
            const ctx = canvas.getContext('2d');

            if (!isLogo) {
                ctx.fillStyle = 'white';
                ctx.fillRect(0, 0, CANVAS_W, CANVAS_H);
            }

            const imgAspect = img.width / img.height;
            let drawW, drawH;

            if (imgAspect > (CANVAS_W / CANVAS_H)) {
                drawH = CANVAS_H * cropZoom;
                drawW = drawH * imgAspect;
            } else {
                drawW = CANVAS_W * cropZoom;
                drawH = drawW / imgAspect;
            }

            // Centralized draw coordinates with user offsets
            // IMPORTANT: Match CSS translate(X%, Y%) relative to elements dimensions
            const offsetX = (cropX / 100) * drawW;
            const offsetY = (cropY / 100) * drawH;

            const x = (CANVAS_W - drawW) / 2 + offsetX;
            const y = (CANVAS_H - drawH) / 2 + offsetY;

            ctx.drawImage(img, x, y, drawW, drawH);

            const dataUrl = isLogo ? canvas.toDataURL('image/png') : canvas.toDataURL('image/jpeg', 0.8);

            if (croppingType === 'barber') {
                setNewBarberImage(dataUrl);
                showToast('Foto do barbeiro ajustada!');
            } else {
                setUnitLogo(dataUrl);
                // Auto-save logo to Firestore for immediate feedback in sidebar
                try {
                    await updateDoc(doc(db, "tenants", currentTenant), {
                        logoUrl: dataUrl
                    });
                    showToast('Logo da unidade atualizada em todo o sistema!', 'success');
                } catch (error) {
                    console.error("Auto-save logo error:", error);
                    showToast('Ajuste aplicado, mas erro ao salvar no banco. Clique em Salvar abaixo.', 'warning');
                }
            }
            setIsCropping(false);
            setUploading(false);
            addLog('Imagem ajustada com sucesso!', 'success');
        };
        img.src = tempImage;
    };

    const handlePointerDown = (e) => {
        setIsDragging(true);
        setLastPointerPos({ x: e.clientX, y: e.clientY });
    };

    const handlePointerMove = (e) => {
        if (!isDragging || !cropContainerRef.current) return;

        const container = cropContainerRef.current;
        const rect = container.getBoundingClientRect();

        // Calculate the actual image width/height in the DOM for proper sensitivity
        // This ensures 1:1 tracking between mouse and image movement
        let imgDisplayW, imgDisplayH;
        const containerAspect = rect.width / rect.height;

        if (tempAspect > containerAspect) {
            imgDisplayH = rect.height;
            imgDisplayW = imgDisplayH * tempAspect;
        } else {
            imgDisplayW = rect.width;
            imgDisplayH = imgDisplayW / tempAspect;
        }

        // Apply zoom to the base dimensions
        const scaledW = imgDisplayW * cropZoom;
        const scaledH = imgDisplayH * cropZoom;

        // Convert pixel delta to percentage of the element itself (matching CSS translate %)
        const deltaX = (e.clientX - lastPointerPos.x) / scaledW * 100;
        const deltaY = (e.clientY - lastPointerPos.y) / scaledH * 100;

        setCropX(prev => prev + deltaX);
        setCropY(prev => prev + deltaY);
        setLastPointerPos({ x: e.clientX, y: e.clientY });
    };

    const handlePointerUp = () => {
        setIsDragging(false);
    };

    const handleAddBarber = async () => {
        if (!newBarberName) return;
        if (!currentTenant) {
            showToast('Erro: ID da barbearia não identificado.', 'error');
            return;
        }
        try {
            if (editingBarberId) {
                addLog(`Atualizando barbeiro: ${newBarberName}`, 'info');
                await withTimeout(updateDoc(doc(db, "barbers", editingBarberId), {
                    name: newBarberName,
                    image: newBarberImage || '/imagens/fotobarber.PNG',
                    email: newBarberEmail?.toLowerCase() || '',
                    whatsapp: newBarberPhone || '',
                    role: newBarberRole || 'barber',
                    workingHours: barberWorkingHours
                }));
                addLog('Barbeiro atualizado com sucesso!', 'success');
                showToast('Barbeiro atualizado!');
                setEditingBarberId(null);
            } else {
                const currentPlan = config?.plan || 'ouro';
                const limit = PLAN_LIMITS[currentPlan] || 5;

                if (barbers.length >= limit) {
                    showToast(`Limite do plano atingido! O plano ${currentPlan.toUpperCase()} permite apenas ${limit} barbeiros.`, 'error');
                    return;
                }

                addLog(`Tentando adicionar barbeiro: ${newBarberName}`, 'info');
                await withTimeout(addDoc(collection(db, "barbers"), {
                    name: newBarberName,
                    image: newBarberImage || '/imagens/fotobarber.PNG',
                    email: newBarberEmail?.toLowerCase() || '',
                    whatsapp: newBarberPhone || '',
                    role: newBarberRole || 'barber',
                    barbershopId: currentTenant,
                    workingHours: barberWorkingHours
                }));
                addLog('Barbeiro adicionado com sucesso ao Firestore!', 'success');
                showToast('Barbeiro adicionado com sucesso!');
            }

            // Se tem e-mail e é admin, garante que está na lista de admins do tenant
            if (newBarberEmail && newBarberRole === 'admin') {
                const tenantRef = doc(db, "tenants", currentTenant);
                const currentEmails = config?.adminEmails || [];
                const lowerEmail = newBarberEmail.toLowerCase();
                if (!currentEmails.includes(lowerEmail)) {
                    await updateDoc(tenantRef, {
                        adminEmails: [...currentEmails, lowerEmail]
                    });
                }
            }

            setNewBarberName('');
            setNewBarberEmail('');
            setNewBarberPhone('');
            setNewBarberRole('barber');
            setNewBarberImage('/imagens/fotobarber.PNG');
            setBarberWorkingHours({
                'Seg': { active: true, start: '08:00', end: '19:00', lunchActive: false, lunchStart: '12:00', lunchEnd: '13:00' },
                'Ter': { active: true, start: '08:00', end: '19:00', lunchActive: false, lunchStart: '12:00', lunchEnd: '13:00' },
                'Qua': { active: true, start: '08:00', end: '19:00', lunchActive: false, lunchStart: '12:00', lunchEnd: '13:00' },
                'Qui': { active: true, start: '08:00', end: '19:00', lunchActive: false, lunchStart: '12:00', lunchEnd: '13:00' },
                'Sex': { active: true, start: '08:00', end: '19:00', lunchActive: false, lunchStart: '12:00', lunchEnd: '13:00' },
                'Sab': { active: true, start: '08:00', end: '19:00', lunchActive: false, lunchStart: '12:00', lunchEnd: '13:00' },
                'Dom': { active: false, start: '08:00', end: '19:00', lunchActive: false, lunchStart: '12:00', lunchEnd: '13:00' },
            });
        } catch (error) {
            addLog('Erro ao salvar barbeiro: ' + error.message, 'error');
            console.error("Erro ao salvar barbeiro:", error);
            showToast('Erro ao salvar barbeiro: ' + error.message, 'error');
        }
    };

    const handleDeleteBarber = async (barberId) => {
        if (window.confirm("Deseja realmente excluir este barbeiro?")) {
            try {
                await deleteDoc(doc(db, "barbers", barberId));
                showToast('Barbeiro excluído');
            } catch (error) {
                console.error("Erro ao excluir barbeiro:", error);
                showToast('Erro ao excluir barbeiro', 'error');
            }
        }
    };

    const handleQuickBlock = async (app) => {
        if (!window.confirm(`Deseja BLOQUEAR o horário ${app.time} para o barbeiro ${app.barber} em ${app.date.split('-').reverse().join('/')}?`)) return;

        try {
            addLog(`Bloqueando horário: ${app.time} - ${app.barber}`, 'info');
            await withTimeout(addDoc(collection(db, "blockedTimes"), {
                date: app.date,
                barber: app.barber,
                time: app.time,
                reason: 'Bloqueio Rápido (Dashboard)',
                tenantId: currentTenant
            }));

            // Also cancel the current appointment if it exists and we're blocking its slot
            if (app.id && app.status !== 'Cancelado') {
                await onUpdateStatus(app.id, 'Cancelado');
            }

            showToast('Horário bloqueado com sucesso!');
        } catch (error) {
            addLog('Erro ao bloquear: ' + error.message, 'error');
            showToast('Erro ao bloquear horário', 'error');
        }
    };

    const handleClearHistory = async () => {
        const historyApps = appointments.filter(app => app.status === 'Concluido' || app.status === 'Cancelado');
        if (historyApps.length === 0) {
            showToast('Nenhum histórico para limpar.', 'info');
            return;
        }

        if (window.confirm(`ATENÇÃO: Deseja realmente EXCLUIR DEFINITIVAMENTE os ${historyApps.length} atendimentos do histórico (Concluídos e Cancelados)?\n\nIsso limpará suas estatísticas de desempenho e faturamento.`)) {
            if (window.confirm("CONFIRMAÇÃO FINAL: Esta ação não pode ser desfeita. Deseja prosseguir?")) {
                try {
                    addLog(`Limpando histórico de ${historyApps.length} itens...`, 'info');
                    const promises = historyApps.map(app => deleteDoc(doc(db, "appointments", app.id)));
                    await Promise.all(promises);
                    addLog('Histórico limpo com sucesso!', 'success');
                    showToast('Histórico limpo com sucesso!');
                } catch (error) {
                    addLog('Erro ao limpar histórico: ' + error.message, 'error');
                    console.error("History cleanup error:", error);
                    showToast('Erro ao limpar histórico', 'error');
                }
            }
        }
    };

    const handleFileChange = async (e, type = 'barber') => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.size > 2 * 1024 * 1024) {
            showToast('A imagem deve ter no máximo 2MB', 'error');
            return;
        }

        setCroppingType(type);
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
                setTempAspect(img.width / img.height);
                setTempImage(event.target.result);
                setIsCropping(true);
                setCropZoom(1);
                setCropX(0);
                setCropY(0);
            };
            img.src = event.target.result;
        };
        reader.readAsDataURL(file);

        // Reset input value to allow re-selecting same file
        e.target.value = '';
    };

    const handleUpdateCategory = async (serviceId, category) => {
        try {
            await updateDoc(doc(db, "services", serviceId), {
                category: category
            });
            showToast('Categoria atualizada');
        } catch (error) {
            showToast('Erro ao atualizar categoria', 'error');
        }
    };

    const handleAddClosedDay = async () => {
        if (!newClosedDay) return;
        try {
            await addDoc(collection(db, "appointments"), {
                date: newClosedDay,
                reason: newClosedReason,
                status: 'Sistema_Bloqueado',
                barbershopId: currentTenant,
                tenantId: currentTenant,
                client: 'SISTEMA',
                barber: 'SHOP'
            });
            setNewClosedDay('');
            showToast('Dia de folga adicionado!');
        } catch (error) {
            console.error("Error adding closed day:", error);
            showToast('Erro ao adicionar dia de folga', 'error');
        }
    };

    const handleDeleteClosedDay = async (id) => {
        if (window.confirm("Deseja reabrir este dia?")) {
            try {
                await deleteDoc(doc(db, "appointments", id));
                showToast('Dia reaberto com sucesso');
            } catch (error) {
                showToast('Erro ao reabrir dia', 'error');
            }
        }
    };

    const handleAddExpense = async () => {
        if (!newExpense.description || !newExpense.amount) {
            showToast('Preencha a descrição e o valor', 'warning');
            return;
        }

        try {
            const amount = parseFloat(newExpense.amount.replace(',', '.'));
            if (isNaN(amount)) {
                showToast('Valor inválido', 'error');
                return;
            }

            let iterations = 1;
            let start = new Date(newExpense.date + 'T12:00:00');

            if (newExpense.isContract) {
                const startDate = new Date(newExpense.contractStartDate + 'T12:00:00');
                const endDate = new Date(newExpense.contractEndDate + 'T12:00:00');

                // Calculate months difference
                iterations = (endDate.getFullYear() - startDate.getFullYear()) * 12 + (endDate.getMonth() - startDate.getMonth()) + 1;
                if (iterations < 1) iterations = 1;
                start = startDate;
            }

            const promises = [];
            for (let i = 0; i < iterations; i++) {
                const currentDate = new Date(start);
                currentDate.setMonth(start.getMonth() + i);

                const monthName = currentDate.toLocaleString('pt-BR', { month: 'long' });
                const yearName = currentDate.getFullYear();

                const expenseData = {
                    description: newExpense.isContract
                        ? `${newExpense.description} - ${monthName}/${yearName}`
                        : newExpense.description,
                    amount: amount,
                    category: newExpense.category,
                    date: currentDate.toISOString().split('T')[0],
                    barbershopId: currentTenant,
                    createdAt: new Date().toISOString()
                };

                promises.push(addDoc(collection(db, "expenses"), expenseData));
            }

            await Promise.all(promises);

            setNewExpense({
                description: '',
                amount: '',
                category: 'Variável',
                date: new Date().toISOString().split('T')[0],
                isContract: false,
                contractStartDate: new Date().toISOString().split('T')[0],
                contractEndDate: new Date(new Date().getFullYear(), new Date().getMonth() + 11, new Date().getDate()).toISOString().split('T')[0]
            });
            showToast(iterations > 1 ? `${iterations} parcelas adicionadas!` : 'Despesa adicionada!');
        } catch (error) {
            console.error("Error adding expense:", error);
            showToast('Erro ao adicionar despesa', 'error');
        }
    };

    const handleDeleteExpense = async (id) => {
        if (window.confirm("Excluir esta despesa?")) {
            try {
                await deleteDoc(doc(db, "expenses", id));
                showToast('Despesa excluída');
            } catch (error) {
                showToast('Erro ao excluir', 'error');
            }
        }
    };

    // Expiry Warning Logic
    const getDaysRemainingNotification = () => {
        if (!config?.dueDate) return null;
        try {
            const due = config.dueDate?.seconds ? new Date(config.dueDate.seconds * 1000) : new Date(config.dueDate);
            const now = new Date();
            const diffTime = due - now;
            return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        } catch (e) { return null; }
    };

    const daysLeft = getDaysRemainingNotification();
    const showExpiryWarning = daysLeft !== null && daysLeft <= 5 && daysLeft >= 0;

    return (
        <div className="owner-panel-container-container">
            {showExpiryWarning && (
                <div className="expiry-warning-banner">
                    <div className="warning-content">
                        <span className="warning-icon">⚠️</span>
                        <p>Sua assinatura vence em <strong>{daysLeft} {daysLeft === 1 ? 'dia' : 'dias'}</strong>. Evite o bloqueio do sistema renovando agora!</p>
                    </div>
                    <button className="warning-btn" onClick={() => setActiveSection('assinatura')}>
                        RENOVAR AGORA
                    </button>
                </div>
            )}

            <div className={`sidebar-backdrop ${isSidebarOpen ? 'show' : ''}`} onClick={() => setIsSidebarOpen(false)} />
            <BarraLateral
                user={user}
                activeSection={activeSection}
                setActiveSection={setActiveSection}
                isSidebarOpen={isSidebarOpen}
                setIsSidebarOpen={setIsSidebarOpen}
                onBack={onBack}
                globalBroadcast={globalBroadcast}
                unitLogo={unitLogo}
                unitName={config?.name}
            />

            <main className="owner-main-content">
                {(() => {
                    const sectionTitles = {
                        dashboard: 'Dashboard',
                        agenda: 'Agenda',
                        services: 'Serviços',
                        team: 'Equipe',
                        financeiro: 'Financeiro',
                        settings: 'Ajustes',
                        reviews: 'Avaliação',
                        marketing: 'Marketing',
                        fidelizacao: 'Fidelização',
                        assinatura: 'Assinatura'
                    };

                    return (
                        <header className="owner-top-header">
                            <button className="mobile-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
                                <span>MENU</span>
                            </button>
                            <h1>{sectionTitles[activeSection] || activeSection}</h1>
                            <div className="header-search">
                                <span>Painel Principal /</span>
                                <b>{sectionTitles[activeSection] || activeSection}</b>
                            </div>
                        </header>
                    );
                })()}

                <div className="owner-section-wrapper">
                    {activeSection === 'dashboard' && (
                        <SecaoDashboard
                            periodRevenue={periodRevenue}
                            timeFilter={timeFilter}
                            formatCurrency={formatCurrency}
                            periodAppointments={appointments}
                            completedCount={appointments.filter(a => a.status === 'Concluido').length}
                            periodAverageTicket={periodAverageTicket}
                            occupancyRate={occupancyRate}
                            periodNetProfit={periodNetProfit}
                            monthlyData={monthlyData}
                            barberPerformance={barberPerformance}
                            goalProgress={goalProgress}
                            currentMonthRevenue={currentMonthRevenue}
                            revenueGoal={revenueGoal}
                            isEditingGoal={isEditingGoal}
                            setIsEditingGoal={setIsEditingGoal}
                            handleSaveUnitConfig={handleSaveUnitConfig}
                            setRevenueGoal={setRevenueGoal}
                            generateMonthlyReport={generateMonthlyReport}
                            pendingReminders={pendingReminders}
                            handleRemind={handleRemind}
                            markAsReminded={markAsReminded}
                            totalClients={new Set(appointments.map(a => a.whatsapp || a.client)).size}
                        />
                    )}

                    {activeSection === 'agenda' && (
                        <SecaoAgenda
                            selectedDate={selectedDate}
                            setSelectedDate={setSelectedDate}
                            generateDailyAgendaPDF={generateDailyAgendaPDF}
                            selectedBarber={selectedBarber}
                            setSelectedBarber={setSelectedBarber}
                            barbers={barbers}
                            agendaSearch={agendaSearch}
                            setAgendaSearch={setAgendaSearch}
                            agendaStatusFilter={agendaStatusFilter}
                            setAgendaStatusFilter={setAgendaStatusFilter}
                            groupedAgenda={groupedAgenda}
                            onUpdateStatus={onUpdateStatus}
                            handleRemind={handleRemind}
                            agendaAppointments={agendaAppointments}
                        />
                    )}

                    {activeSection === 'financeiro' && (
                        <SecaoFinanceiro
                            financeiroStartDate={financeiroStartDate}
                            setFinanceiroStartDate={setFinanceiroStartDate}
                            financeiroEndDate={financeiroEndDate}
                            setFinanceiroEndDate={setFinanceiroEndDate}
                            periodRevenue={periodRevenue}
                            formatCurrency={formatCurrency}
                            periodExpenses={periodExpenses}
                            periodNetProfit={periodNetProfit}
                            newExpense={newExpense}
                            setNewExpense={setNewExpense}
                            handleAddExpense={handleAddExpense}
                            expenses={expenses}
                            handleDeleteExpense={handleDeleteExpense}
                        />
                    )}

                    {activeSection === 'team' && (
                        <SecaoEquipe
                            editingBarberId={editingBarberId}
                            newBarberImage={newBarberImage}
                            handleFileChange={handleFileChange}
                            newBarberName={newBarberName}
                            setNewBarberName={setNewBarberName}
                            barberWorkingHours={barberWorkingHours}
                            setBarberWorkingHours={setBarberWorkingHours}
                            handleAddBarber={handleAddBarber}
                            setEditingBarberId={setEditingBarberId}
                            setNewBarberImage={setNewBarberImage}
                            barbers={barbers}
                            currentTenant={currentTenant}
                            handleDeleteBarber={handleDeleteBarber}
                            newBarberEmail={newBarberEmail}
                            setNewBarberEmail={setNewBarberEmail}
                            newBarberPhone={newBarberPhone}
                            setNewBarberPhone={setNewBarberPhone}
                            newBarberRole={newBarberRole}
                            setNewBarberRole={setNewBarberRole}
                        />
                    )}

                    {activeSection === 'services' && (
                        <SecaoServicos
                            newServiceName={newServiceName}
                            setNewServiceName={setNewServiceName}
                            newServicePrice={newServicePrice}
                            setNewServicePrice={setNewServicePrice}
                            newServiceDuration={newServiceDuration}
                            setNewServiceDuration={setNewServiceDuration}
                            newServiceCategory={newServiceCategory}
                            setNewServiceCategory={setNewServiceCategory}
                            handleAddService={handleAddService}
                            services={services}
                            collapsedCategories={collapsedCategories}
                            toggleCategory={toggleCategory}
                            editingPriceId={editingPriceId}
                            editingPrice={editingPrice}
                            setEditingPrice={setEditingPrice}
                            setEditingPriceId={setEditingPriceId}
                            handleUpdateServicePrice={handleUpdateServicePrice}
                            editingServiceId={editingServiceId}
                            editingDuration={editingDuration}
                            setEditingDuration={setEditingDuration}
                            setEditingServiceId={setEditingServiceId}
                            handleUpdateServiceDuration={handleUpdateServiceDuration}
                            handleDeleteService={handleDeleteService}
                        />
                    )}

                    {activeSection === 'settings' && (
                        <SecaoConfiguracoes
                            unitLogo={unitLogo}
                            handleFileChange={handleFileChange}
                            unitAddress={unitAddress}
                            setUnitAddress={setUnitAddress}
                            unitMapsUrl={unitMapsUrl}
                            setUnitMapsUrl={setUnitMapsUrl}
                            unitWhatsapp={unitWhatsapp}
                            setUnitWhatsapp={setUnitWhatsapp}
                            unitInstagram={unitInstagram}
                            setUnitInstagram={setUnitInstagram}
                            revenueGoal={revenueGoal}
                            setRevenueGoal={setRevenueGoal}
                            unitHours={unitHours}
                            setUnitHours={setUnitHours}
                            handleSaveUnitConfig={handleSaveUnitConfig}
                            newClosedDay={newClosedDay}
                            setNewClosedDay={setNewClosedDay}
                            newClosedReason={newClosedReason}
                            setNewClosedReason={setNewClosedReason}
                            handleAddClosedDay={handleAddClosedDay}
                            systemBlocks={systemBlocks}
                            handleDeleteClosedDay={handleDeleteClosedDay}
                        />
                    )}

                    {activeSection === 'marketing' && (
                        <SecaoMarketing
                            currentTenant={currentTenant}
                            config={config}
                            showToast={showToast}
                        />
                    )}

                    {activeSection === 'fidelizacao' && (
                        <SecaoFidelizacao
                            ghostClients={ghostClients}
                            shopName={config?.name || 'nossa barbearia'}
                        />
                    )}

                    {activeSection === 'assinatura' && (
                        <SecaoAssinatura
                            config={config}
                            barbers={barbers}
                            currentTenant={currentTenant}
                        />
                    )}
                </div>
            </main>

            {isCropping && (
                <div className="cropping-overlay">
                    <div className="cropping-modal">
                        <h3>Ajustar Imagem</h3>
                        <p>Arraste para posicionar e use o zoom para ajustar</p>

                        <div
                            className={`crop-view-container ${croppingType === 'logo' ? 'aspect-logo' : 'aspect-square'}`}
                            ref={cropContainerRef}
                            onPointerDown={handlePointerDown}
                            onPointerMove={handlePointerMove}
                            onPointerUp={handlePointerUp}
                            onPointerLeave={handlePointerUp}
                        >
                            <img
                                src={tempImage}
                                alt="Ajuste"
                                className="crop-image-preview"
                                style={{
                                    transform: `translate(calc(-50% + ${cropX}%), calc(-50% + ${cropY}%)) scale(${cropZoom})`,
                                    cursor: isDragging ? 'grabbing' : 'grab'
                                }}
                                draggable="false"
                            />
                            <div className="crop-mask"></div>
                        </div>

                        <div className="crop-controls">
                            <div className="zoom-control">
                                <span>Zoom</span>
                                <input
                                    type="range"
                                    min="1"
                                    max="3"
                                    step="0.01"
                                    value={cropZoom}
                                    onChange={(e) => setCropZoom(parseFloat(e.target.value))}
                                />
                            </div>

                            <div className="crop-actions">
                                <button className="crop-btn cancel" onClick={() => setIsCropping(false)}>
                                    Cancelar
                                </button>
                                <button className="crop-btn confirm" onClick={handleApplyCrop} disabled={uploading}>
                                    {uploading ? 'Salvando...' : 'Confirmar Ajuste'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PainelDono;
